import SSAccountCard from "@core-components/accountCard/SSAccountCard";
import SSBoughtFooterCard from "@core-components/accountCard/components/SSBoughtFooterCard";
import SSHeaderCard from "@core-components/accountCard/components/SSHeaderCard";
import ProductDetailLine from "@core-components/product-detail-line/ProductDetailLine";
import SSHeadline from "@core-components/title/SSHeadline";
import SSWhiteText from "@core-components/title/components/SSWhiteText";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { Space, Stack } from "@mantine/core";
import { useLoLRankedAsBasketAccount } from "@modules/order/hooks/useBasketItem.hook";
import SSRankedCardFooter from "@modules/ranked/components/SSRankedCardFooter";
import {
  IconDroplet,
  IconTrophy,
  IconUserFilled,
  IconUsers,
  IconWorld,
} from "@tabler/icons-react";
import type { IRankedSmurfCardItem } from "../models/IRankedSmurf.models";

interface ISSRankedCardProps {
  account: IRankedSmurfCardItem;
}

const SSRankedCard: React.FC<ISSRankedCardProps> = ({ account }) => {
  const { t } = useAppTranslation("components.rankedCard");
  const { t: rankT } = useAppTranslation();

  return (
    <SSAccountCard
      header={
        <SSHeaderCard
          variant="ranked"
          alt={t("emblemAlt", {
            rank: account.rankedInformation.currentRankInformation.rank,
          })}
          backgroundUrl={
            account.rankedInformation.currentRankInformation.emblem
          }
          mainColor={account.rankedInformation.currentRankInformation.color}
        >
          <SSHeadline
            props={{
              stack: {
                className: "w-full",
                align: "left",
              },
              title: {
                component: "p",
                className: "uppercase font-secret-black",
                fz: 22,
              },
            }}
          >
            <SSWhiteText>
              {t("title", {
                region: account.region,
                rank: rankT(
                  `products.lol.${account.rankedInformation.currentRankInformation.rank}.rank`,
                  {
                    subRank:
                      account.rankedInformation.currentRankInformation.subRank,
                  },
                ),
              })}
            </SSWhiteText>
          </SSHeadline>
        </SSHeaderCard>
      }
    >
      <Stack className="pb-3" gap={10}>
        <ProductDetailLine
          color="#FF7A00"
          description={account.region}
          icon={IconWorld}
          label={t("region")}
        />
        <ProductDetailLine
          color="#f5cb42"
          description={rankT(
            `products.lol.${account.rankedInformation.currentRankInformation.rank}.rank`,
            {
              subRank: account.rankedInformation.currentRankInformation.subRank,
            },
          )}
          icon={IconTrophy}
          label={t("rank")}
        />
        <ProductDetailLine
          color="#60A9FF"
          description={account.blueEssence}
          icon={IconDroplet}
          label={t("blueEssence")}
        />
        <ProductDetailLine
          color="#f54263"
          description={account.rankedInformation.championsAmount}
          icon={IconUsers}
          label={t("champions")}
        />
        <ProductDetailLine
          color="#6642f5"
          description={account.rankedInformation.skinsShardAmount}
          icon={IconUserFilled}
          label={t("skinShards")}
        />
        <Space h={5} />
        <SSBoughtFooterCard account={useLoLRankedAsBasketAccount(account)} />
        <SSRankedCardFooter puuid={account.puuid} />
      </Stack>
    </SSAccountCard>
  );
};

export default SSRankedCard;
